// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3SSwZ","amount":"Amount_amount__7vdxK","tip":"Amount_tip__1VK_7","tipHeader":"Amount_tipHeader__19RtB","tipsWrap":"Amount_tipsWrap__2V4C-"};